import React, { createContext, useCallback, useContext, useState } from 'react';
import { ContactSupportSheet } from '../../components/support/ContactSupportSheet';
import type { SupportCaseType } from '../../services/supportService';

interface OpenSupportOptions {
  featureId?: string;
  type?: SupportCaseType;
}

interface SupportContextValue {
  openSupport: (options?: OpenSupportOptions) => void;
}

const SupportContext = createContext<SupportContextValue>({
  openSupport: () => undefined,
});

export function SupportProvider({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<OpenSupportOptions>({});

  const openSupport = useCallback((next?: OpenSupportOptions) => {
    setOptions(next || {});
    setOpen(true);
  }, []);

  return (
    <SupportContext.Provider value={{ openSupport }}>
      {children}
      <ContactSupportSheet
        open={open}
        featureId={options.featureId}
        initialType={options.type}
        onClose={() => setOpen(false)}
      />
    </SupportContext.Provider>
  );
}

export function useSupport(): SupportContextValue {
  return useContext(SupportContext);
}
